// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16E4W","clinicsSelect":"styles_clinicsSelect__Iosyv"};